import { render } from "./pc_wechat_open_platform.vue?vue&type=template&id=1dbd6960&scoped=true"
import script from "./pc_wechat_open_platform.vue?vue&type=script&lang=js"
export * from "./pc_wechat_open_platform.vue?vue&type=script&lang=js"

import "./pc_wechat_open_platform.vue?vue&type=style&index=0&id=1dbd6960&scoped=true&lang=css"

import exportComponent from "/vuebuild/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dbd6960"]])

export default __exports__